import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher: React.FC<{ size?: 'small' | 'medium'; fullWidth?: boolean; label?: string }>
  = ({ size = 'small', fullWidth = false, label }) => {
  const { i18n } = useTranslation();
  const [lang, setLang] = React.useState<string>(i18n.resolvedLanguage || i18n.language || 'fr');

  const handleChange = (_: unknown, value: string | null) => {
    if (!value) return;
    setLang(value);
    i18n.changeLanguage(value);
    try {
      window.localStorage.setItem('i18nextLng', value);
    } catch {}
  };

  return (
    <FormControl 
      size={size} 
      fullWidth={fullWidth}
      sx={{
        '& .MuiInputLabel-root': {
          color: 'rgba(255,255,255,0.7)',
          '&.Mui-focused': {
            color: '#f1c086',
          },
        },
        '& .MuiSelect-select': {
          backgroundColor: '#1a1a1a',
          color: '#fff',
          borderRadius: '8px',
          height: size === 'small' ? '40px' : '56px',
          display: 'flex',
          alignItems: 'center',
          '&:focus': {
            backgroundColor: '#1a1a1a',
          },
        },
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: 'transparent',
        },
        '& .MuiSelect-root:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: '#f1c086',
        },
        '& .MuiSelect-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: '#f1c086',
        },
        '& .MuiSelect-icon': {
          color: 'rgba(255,255,255,0.7)',
        },
      }}
    >
      {label ? (
        <InputLabel 
          id="lang-label"
          sx={{
            color: 'rgba(255,255,255,0.7)',
            '&.Mui-focused': {
              color: '#f1c086',
            },
          }}
        >
          {label}
        </InputLabel>
      ) : null}
      <Select
        labelId="lang-label"
        value={lang}
        label={label}
        onChange={(e) => handleChange(null, e.target.value as string)}
        sx={{
          '& .MuiSelect-select': {
            backgroundColor: '#1a1a1a',
            color: '#fff',
            borderRadius: '8px',
            '&:focus': {
              backgroundColor: '#1a1a1a',
            },
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'transparent',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#f1c086',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#f1c086',
          },
          '& .MuiSelect-icon': {
            color: 'rgba(255,255,255,0.7)',
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              backgroundColor: '#1a1a1a',
              border: '1px solid rgba(241, 192, 134, 0.3)',
              borderRadius: '8px',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.5)',
              '& .MuiMenuItem-root': {
                color: '#fff',
                backgroundColor: '#1a1a1a',
                '&:hover': {
                  backgroundColor: 'rgba(241, 192, 134, 0.1)',
                },
                '&.Mui-selected': {
                  backgroundColor: 'rgba(241, 192, 134, 0.2)',
                  '&:hover': {
                    backgroundColor: 'rgba(241, 192, 134, 0.3)',
                  },
                },
              },
            },
          },
        }}
      >
        <MenuItem value="fr">Français</MenuItem>
        <MenuItem value="en">English</MenuItem>
        <MenuItem value="es">Español</MenuItem>
        <MenuItem value="de">Deutsch</MenuItem>
        <MenuItem value="it">Italiano</MenuItem>
        <MenuItem value="pt">Português</MenuItem>
        <MenuItem value="hi">हिन्दी</MenuItem>
        <MenuItem value="zh">中文</MenuItem>
      </Select>
    </FormControl>
  );
};

export default LanguageSwitcher;